import BloodGlucoseThresholds from "./BloodGlucoseThresholds"
import BloodPressureThresholds from "./BloodPressureThresholds"

export const clinicalProtocolTypes = ["diabetes", "hypertension"] as const
export type ClinicalProtocolType = (typeof clinicalProtocolTypes)[number]

export type DiabetesProtocol = {
  type: "diabetes"
  name: string
  bloodGlucoseThresholds: BloodGlucoseThresholds
}

export type HypertensionProtocol = {
  type: "hypertension"
  name: string
  bloodPressureThresholds: BloodPressureThresholds
}

export type ClinicalProtocol = DiabetesProtocol | HypertensionProtocol

export type ClinicalProtocolApiDto = ClinicalProtocol
